import { ReportIssueHandlerProvider } from './report-issue-handler.provider';
import { ReportIssueHandlerContent } from './report-issue-handler-content.component';

export function ReportIssueHandler() {
  return (
    <ReportIssueHandlerProvider>
      <ReportIssueHandlerContent />
    </ReportIssueHandlerProvider>
  );
}
